import moment from 'moment';
let _store = null; // Module-scoped store reference

const  Localization = {
	install(Vue, { store }) {
    _store = store; // Store saved globally for use in helper functions
        var date_formats = {};

        Vue.mixin({  
            created(){
                date_formats = store.getters['localizationStore/getDateFormats']
            }, 
            methods:{
                $t(term){ 
                    if(!term) return ''
                    return this.$store.getters['localizationStore/toLocal'](term) 
                },
                $td(date, format){
                    // this method is not currently used anywhere, we can delete it or repurpose it for something else
                    return this.$store.getters['localizationStore/toLocalDate'](date, format)
                }, 
                $tn(number){ 
                    return term
                },
                /*
                $tp(){ 
                    return this.$store.getters['localizationStore/getPhoneCodes']?.length ? this.$store.getters['localizationStore/getPhoneCodes'][0] : "";
                },
                */
                $tp(properties){

                    // if no properties passed in, attempt to grab properties from global property selector and compare
                    // if all properties in global property selector are from same country, set that country's code as default
                    // if there are more than 1 countries in the global properties, set the default country's code as first code in localization list
                    if(!properties || (properties && properties.length === 0)){
                        let filteredProperties = this.$store.getters['propertiesStore/filtered']?.length ? this.$store.getters['propertiesStore/filtered'] : [];

                        if(filteredProperties.length){
                            let countries = this.$store.getters['localizationStore/getCountries']?.length ? this.$store.getters['localizationStore/getCountries'] : [];

                            let uniqueEntries = [];

                            countries.forEach(c => {
                                if (filteredProperties.some(p => p.Address.country === c.country)) {
                                    uniqueEntries.push(c.code);
                                }
                            });

                            if(uniqueEntries.length === 1){
                                return uniqueEntries[0];
                            } else {
                                return this.$store.getters['localizationStore/getCountries']?.length ? this.$store.getters['localizationStore/getCountries'][0].code : "1";
                            }
                        } else {
                            return this.$store.getters['localizationStore/getCountries']?.length ? this.$store.getters['localizationStore/getCountries'][0].code : "1";
                        }
                    }
                    
                    // for if properties are manually passed in, for if we eventually want more unique behavior for a specific place
                    // if all properties passed into here are from same country, set that country's code as default
                    // if there are more than 1 countries in these properties, set the default country's code as first code in localization list
                    else if(properties && properties.length){
                        let countries = this.$store.getters['localizationStore/getCountries']?.length ? this.$store.getters['localizationStore/getCountries'] : [];

                        let uniqueEntries = [];

                        countries.forEach(c => {
                            if (properties.some(p => p.Address.country === c.country)) {
                                uniqueEntries.push(c.code);
                            }
                        });

                        if(uniqueEntries.length === 1){
                            return uniqueEntries[0];
                        } else {
                            return this.$store.getters['localizationStore/getCountries']?.length ? this.$store.getters['localizationStore/getCountries'][0].code : "1";
                        }
                    } else {
                        return '1';
                    }
                },
                $tp_reorder(codes){
                    if(!codes) return ''

                    if(codes.length){
                        let reorderedPhoneCodes = [];
                        let localizationPhoneCodes = this.$store.getters['localizationStore/getPhoneCodes']?.length ? this.$store.getters['localizationStore/getPhoneCodes'] : [];
                        localizationPhoneCodes.forEach( l => {
                            codes.splice(codes.indexOf(l), 1);
                        });
                        reorderedPhoneCodes = [
                            ...localizationPhoneCodes,
                            ...codes
                        ];
                        return reorderedPhoneCodes;
                    } else {
                        return '';
                    }
                },
                $tc(properties){

                    // if no properties passed in, attempt to grab properties from global property selector and compare
                    // if all properties in global property selector are from same country, set that country as default
                    // if there are more than 1 countries in the global properties, set the default country as first country in localization list
                    if(!properties || (properties && properties.length === 0)){
                        let filteredProperties = this.$store.getters['propertiesStore/filtered']?.length ? this.$store.getters['propertiesStore/filtered'] : [];

                        if(filteredProperties.length){
                            let countries = this.$store.getters['localizationStore/getCountries']?.length ? this.$store.getters['localizationStore/getCountries'] : [];

                            let uniqueEntries = [];

                            countries.forEach(c => {
                                if (filteredProperties.some(p => p.Address.country === c.country)) {
                                    uniqueEntries.push(c.country);
                                }
                            });

                            if(uniqueEntries.length === 1){
                                return uniqueEntries[0];
                            } else {
                                return this.$store.getters['localizationStore/getCountries']?.length ? this.$store.getters['localizationStore/getCountries'][0].country : "United States";
                            }
                        } else {
                            return this.$store.getters['localizationStore/getCountries']?.length ? this.$store.getters['localizationStore/getCountries'][0].country : "United States";
                        }
                    }
                    
                    // for if properties are manually passed in, for if we eventually want more unique behavior for a specific place
                    // if all properties passed into here are from same country, set that country as default
                    // if there are more than 1 countries in these properties, set the default country as first country in localization list
                    else if(properties && properties.length){
                        let countries = this.$store.getters['localizationStore/getCountries']?.length ? this.$store.getters['localizationStore/getCountries'] : [];

                        let uniqueEntries = [];

                        countries.forEach(c => {
                            if (properties.some(p => p.Address.country === c.country)) {
                                uniqueEntries.push(c.country);
                            }
                        });

                        if(uniqueEntries.length === 1){
                            return uniqueEntries[0];
                        } else {
                            return this.$store.getters['localizationStore/getCountries']?.length ? this.$store.getters['localizationStore/getCountries'][0].country : "United States";
                        }
                    } else {
                        return 'United States';
                    }
                },
                $tc_reorder(countries){
                    if(!countries) return '';

                    if(countries.length){
                        let localizationCountries = this.$store.getters['localizationStore/getCountryNames']?.length ? this.$store.getters['localizationStore/getCountryNames'] : [];
                        if(localizationCountries && localizationCountries.length){
                            localizationCountries.forEach( (l, i) => {
                                var localizationCountriesIndex = countries.findIndex(x => x.name == l);
                                var tempCountriesObj = countries[localizationCountriesIndex];
                                countries[localizationCountriesIndex] = countries[i];
                                countries[i] = tempCountriesObj;
                            });
                            return [
                                ...countries.map(item => item.name)
                            ];
                        } else {
                            return [
                                ...countries.filter(item => item.name === 'United States').map(item => item.name),
                                ...countries.filter(item => item.name !== 'United States').map(item => item.name)
                            ];
                        }
                    } else {
                        return '';
                    }
                },
                $t_flag(flag){ 
                    if(!flag) return true;
                    return this.$store.getters['localizationStore/getFlag'](flag) ? this.$store.getters['localizationStore/getFlag'](flag) : '';
                },
                $t_token(token){
                    if(!token) return true;
                    return this.$store.getters['localizationStore/getDisabledToken'](token)
                },
                $load_date_formats(){
                    date_formats = this.$store.getters['localizationStore/getDateFormats']
                }
            },
            filters: {
                formatShortDate(value){ 
                    if (!value || moment(value).format() == 'Invalid date') return '';
                    
                    if(date_formats.short){
                        return moment.utc(value).format(date_formats.short);
                    } else {
                        return moment.utc(value).format('MM/DD/YYYY');
                    }
                },
                formatDate(value){ 
                    if (!value || moment(value).format() == 'Invalid date') return '';
                    
                    if(date_formats.medium){
                        return moment.utc(value).format(date_formats.medium);
                    } else {
                        return moment.utc(value).format('MMM D, YYYY');
                    }
                },
                formatDateTime(value, local = true){ 
                    if (!value || moment(value).format() == 'Invalid date') return '';

                    let format = date_formats.long || 'MMM D, YYYY @ h:mma';
                    if (local) {
                        return moment.utc(value).local().format(format);
                    } else {
                        return moment.utc(value).format(format);
                    }
                }
            }
        });    

	}
};

// TODO: Refactor for more efficient and accessible usage across stores and components
export function t(term) {
  if (!term) return '';
  return _store.getters['localizationStore/toLocal'](term);
}
export default Localization;